export default __webpack_public_path__ + "static/media/undraw_ideation_2a64.e11c666d.svg";